import { Building } from 'lucide-react'

import { AppraisalField } from '@/components/deals/appraisal/AppraisalField'
import { AppraisalSection } from '@/components/deals/appraisal/AppraisalSection'

const DEFAULT_STATE = {
  monthlyHoldingCosts: '',
  monthsToRefinance: '',
}

export function HoldingAssumptionsPanel({ state, onStateChange }) {
  const holdingState = { ...DEFAULT_STATE, ...state }

  function updateField(field, value) {
    onStateChange?.({ ...holdingState, [field]: value })
  }

  return (
    <AppraisalSection title="Holding Assumptions" icon={Building}>
      <div className="grid gap-5 md:grid-cols-2">
        <AppraisalField
          label="Monthly Holding Costs"
          value={holdingState.monthlyHoldingCosts}
          prefix="£"
          suffix="/mo"
          inputMode="decimal"
          className="bg-muted/30 font-bold focus-visible:bg-background"
          onChange={(event) => updateField('monthlyHoldingCosts', event.target.value)}
        />
        <AppraisalField
          label="Months to Refinance"
          value={holdingState.monthsToRefinance}
          suffix="Months"
          inputMode="numeric"
          className="bg-muted/30 font-bold focus-visible:bg-background"
          onChange={(event) => updateField('monthsToRefinance', event.target.value)}
        />
      </div>
    </AppraisalSection>
  )
}
